// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\OpeningHourListResponse

import { hydrateOpeningHour, type OpeningHour, type OpeningHourApiResponse } from './openingHour.gen';

export type OpeningHourListApiResponse = {
	items: OpeningHourApiResponse[];
};

export type OpeningHourList = {
	items: OpeningHour[];
};

export function hydrateOpeningHourList(data: OpeningHourListApiResponse): OpeningHourList {
	return {
		...data,
		items: data.items.map(hydrateOpeningHour),
	};
}